module.exports = __webpack_public_path__ + "static/media/gM5.c11bba12.jpg";